import React, { Component } from 'react';
import $ from 'jquery';
import '../../css/navTop.css';

class Navtop extends Component {

	componentDidMount(){
		$("#navtopicn").fadeOut();
		this.checkScrollIconVisibility();
	}
	componentDidUpdate(){
		var me = this;
		
		setTimeout(function(){
			me.windowscrollupdate();
			me.modalscrollupdate();
		},200);
		
	}
	checkScrollIconVisibility(){
		var me = this;
		$(window).scroll(function() {			
			me.windowscrollupdate();
        });
		 
		$(".modal").scroll(function() {           
			me.modalscrollupdate();
        });
	}
	windowscrollupdate(){
		var me = this;
		if (me.isVisible(".modal") == false) {
            if ($(window).scrollTop() > 100) {
                $("#navtopicn").fadeIn();
            } else {
                $("#navtopicn").fadeOut();
            }
		}
	}
	modalscrollupdate(){
		var me = this;
		if (me.isVisible(".modal") == true){
			if ($(".modal").scrollTop() > 100) {
	            $("#navtopicn").fadeIn();
	        } else {
	            $("#navtopicn").fadeOut();
	        }
		}
	}
	scrollToTop() {
		let intervalId = setInterval(this.scrollStep.bind(this), 100);
		this.setState({ intervalId: intervalId });
	}

	isVisible(element) {
		var element = $(element);
		if (element.length > 0 && element.css('visibility') !== 'hidden' && element.css('display') !== 'none') {
			return true;
		} else {
			return false;
		}
	}

	scrollStep() {

		if (this.isVisible(".modal")) {
			$(".modal").animate({ scrollTop: 0 }, '500');
			clearInterval(this.state.intervalId);
		} else {
			$("HTML, BODY").animate({ scrollTop: 0 }, '500');
			clearInterval(this.state.intervalId);
		}
		console.log("scrollStep" + window.pageYOffset)
	}

	render() {
		return (
			<div id="navtopicn" className="hidden">
				<span id="fltarr" onClick={() => { this.scrollToTop(); }} >
					<a className="cd-top js-cd-top" id="fltoparrow"><i className="material-icons">arrow_upward</i></a>
				</span>
			</div>
		)
	}
}
export default Navtop;


// WEBPACK FOOTER //
// ./src/views/common/Navtop.js